<div
  *ngIf="module"
  [attr.id]="module.slug || null"
  [attr.data-ancnav]="module.slug || null"
  class="content-module bloc-special-module"
  [attr.data-subtype]="module.subtype"
  [attr.data-solution]="!!module.solution.length"
  [attr.data-has-surtitle]="!!module.surtitle"
>

  <div class="bloc-special__surtitle subtitle--two" *ngIf="module.surtitle">{{ module. surtitle }}</div>

  <svg class="bloc-special__sticker" *ngIf="module.subtype !== 'regle' && module.subtype !== 'ensavoirplus'">
    <use [attr.xlink:href]="'#sticker--'+module.subtype" />
  </svg>

  <h3
    *ngIf="computedTitle"
    [class.color--600]="module.subtype !== 'regle'"
    [ngClass]="titleClasses"
  >
    {{ computedTitle }}
  </h3>

  <div class="bloc-special__inner">
    <svg class="bloc-special__sticker" *ngIf="module.subtype !== 'regle' && module.subtype === 'ensavoirplus'">
      <use [attr.xlink:href]="'#sticker--'+module.subtype" />
    </svg>

    <div
      *ngIf="module.text"
      [innerHTML]="module.text"
      [class.title--h3]="module.subtype === 'important'"
      class="bloc-special__text"
    ></div>

    <ng-container *ngFor="let subModule of module.submodules">
      <app-text *ngIf="subModule.type === 'text'" [module]="subModule"></app-text>
      <app-links-module *ngIf="subModule.type === 'tableOfContents'" [module]="subModule"></app-links-module>
      <app-multi-column *ngIf="subModule.type === 'multiColumn'" [module]="subModule"></app-multi-column>
      <app-image *ngIf="subModule.type === 'media'" [module]="subModule"></app-image>
      <app-video *ngIf="subModule.type === 'youtube'" [module]="subModule"></app-video>
      <app-list-steps *ngIf="subModule.type === 'listSteps'" [module]="subModule" [parentModule]="module"></app-list-steps>
    </ng-container>
  </div>

  <div class="bloc-special__solution" *ngIf="module.solution.length" (click)="toggleSolution()" [attr.data-show-solution]="!!showSolution">
    <h4 class="bloc-special__solution__title">
      {{'Common.Library.Modules.solution_title'|translate}}
      <span class="bloc-special__solution__title-icon icon icon-arrow-sm"></span>
    </h4>

    <div class="bloc-special__solution__inner" *ngIf="showSolution" [@toggleSolution]>
      <ng-container *ngFor="let subModule of module.solution">
        <app-text *ngIf="subModule.type === 'text'" [module]="subModule"></app-text>
        <app-links-module *ngIf="subModule.type === 'tableOfContents'" [module]="subModule"></app-links-module>
        <app-multi-column *ngIf="subModule.type === 'multiColumn'" [module]="subModule"></app-multi-column>
        <app-image *ngIf="subModule.type === 'media'" [module]="subModule"></app-image>
        <app-video *ngIf="subModule.type === 'youtube'" [module]="subModule"></app-video>
        <app-list-steps *ngIf="subModule.type === 'listSteps'" [module]="subModule"></app-list-steps>
      </ng-container>
    </div>
  </div>

</div>
